import { defineStyle } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

import { buttonSizes } from "@/theme/helpers";

export const TextareaTheme = defineStyle({
  defaultProps: {
    size: "sm",
  },
  baseStyle: {
    bg: "appBackground",
    "&::placeholder": {
      color: "dimmed",
    },
  },
  variants: {
    outline: (props) => ({
      bg: mode("white", "gray.850")(props),
      borderColor: mode("gray.250", "gray.650")(props),
      boxShadow: "sm",
      // _focus: focusResetStyle,
      // _hover: {
      //   borderColor: mode("gray.350", "gray.600")(props),
      // },
    }),
  },
  sizes: {
    xs: {
      ...buttonSizes.xs,
    },
    sm: {
      ...buttonSizes.sm,
      borderRadius: "md",
    },
    md: {
      ...buttonSizes.md,
    },
    lg: {
      ...buttonSizes.lg,
    },
  },
});
